import {
  AlertCircle,
  Award,
  BarChart3,
  Bone,
  Calendar,
  Check,
  ChevronRight,
  Circle,
  Clock,
  Cloud,
  DollarSign,
  Eye,
  FileText,
  Gem,
  Globe,
  GraduationCap,
  Handshake,
  Heart,
  HelpCircle,
  Home,
  Image,
  Inbox,
  Info,
  Lightbulb,
  Mail,
  MapPin,
  MessageCircle,
  MessageSquare,
  Microscope,
  Package,
  Pencil,
  Phone,
  RefreshCw,
  ScrollText,
  Search,
  ShoppingCart,
  Siren,
  Smartphone,
  Smile,
  Sparkles,
  Stethoscope,
  Timer,
  Trash2,
  User,
  Wrench,
  X,
} from 'lucide-react';
import {
  FacebookIcon,
  InstagramIcon,
  LinkedinIcon,
  TwitterIcon,
} from './brandIcons';

export const ICON_MAP = {
  alertCircle: AlertCircle,
  award: Award,
  barChart3: BarChart3,
  bone: Bone,
  calendar: Calendar,
  check: Check,
  chevronRight: ChevronRight,
  circle: Circle,
  clock: Clock,
  cloud: Cloud,
  dollarSign: DollarSign,
  eye: Eye,
  fileText: FileText,
  facebook: FacebookIcon,
  gem: Gem,
  globe: Globe,
  graduationCap: GraduationCap,
  handshake: Handshake,
  heart: Heart,
  helpCircle: HelpCircle,
  home: Home,
  image: Image,
  inbox: Inbox,
  info: Info,
  instagram: InstagramIcon,
  lightbulb: Lightbulb,
  linkedin: LinkedinIcon,
  mail: Mail,
  mapPin: MapPin,
  messageCircle: MessageCircle,
  messageSquare: MessageSquare,
  microscope: Microscope,
  package: Package,
  pencil: Pencil,
  phone: Phone,
  refreshCw: RefreshCw,
  scrollText: ScrollText,
  search: Search,
  shoppingCart: ShoppingCart,
  siren: Siren,
  smartphone: Smartphone,
  smile: Smile,
  sparkles: Sparkles,
  stethoscope: Stethoscope,
  timer: Timer,
  trash2: Trash2,
  twitter: TwitterIcon,
  user: User,
  wrench: Wrench,
  x: X,
};

export const EMOJI_TO_ICON = {
  '🦷': 'stethoscope',
  '✨': 'sparkles',
  '🔧': 'wrench',
  '🦴': 'bone',
  '😁': 'smile',
  '🌟': 'sparkles',
  '💎': 'gem',
  '⚕️': 'stethoscope',
  '🚨': 'siren',
  '📞': 'phone',
  '⏰': 'clock',
  '⏱️': 'timer',
  '✉️': 'mail',
  '📍': 'mapPin',
  '💬': 'messageCircle',
  '📷': 'instagram',
  '🐦': 'twitter',
  '🔍': 'search',
  '📦': 'package',
  '🎓': 'graduationCap',
  '📜': 'award',
  '❤️': 'heart',
  '🔬': 'microscope',
  '🤝': 'handshake',
  '📅': 'calendar',
  '💰': 'dollarSign',
  '📝': 'fileText',
  '💡': 'lightbulb',
  '👁️': 'eye',
  '🛒': 'shoppingCart',
  '📊': 'barChart3',
  '🔄': 'refreshCw',
  '✏️': 'pencil',
  '🏠': 'home',
  '❓': 'helpCircle',
  '🧾': 'scrollText',
  '👩': 'user',
  '👨': 'user',
  '👩‍🦰': 'user',
  '👨‍⚕️': 'stethoscope',
  'ℹ️': 'info',
  '💼': 'award',
  '🗑️': 'trash2',
  '📬': 'inbox',
  '📱': 'smartphone',
  '🌐': 'globe',
  '☁️': 'cloud',
};

export const SERVICE_ICON_DEFAULTS = {
  'general-checkup': 'stethoscope',
  'teeth-cleaning': 'sparkles',
  'cosmetic-dentistry': 'gem',
  'orthodontics': 'wrench',
  'dental-implants': 'bone',
  'teeth-whitening': 'smile',
  'emergency-care': 'siren',
};

export const ICON_OPTIONS = [
  { value: 'stethoscope', label: 'Stethoscope' },
  { value: 'sparkles', label: 'Sparkles' },
  { value: 'wrench', label: 'Wrench' },
  { value: 'bone', label: 'Bone' },
  { value: 'smile', label: 'Smile' },
  { value: 'gem', label: 'Gem' },
  { value: 'siren', label: 'Siren' },
  { value: 'heart', label: 'Heart' },
  { value: 'microscope', label: 'Microscope' },
  { value: 'handshake', label: 'Handshake' },
  { value: 'phone', label: 'Phone' },
  { value: 'mail', label: 'Mail' },
  { value: 'clock', label: 'Clock' },
  { value: 'calendar', label: 'Calendar' },
  { value: 'mapPin', label: 'Map Pin' },
  { value: 'package', label: 'Package' },
  { value: 'award', label: 'Award' },
  { value: 'graduationCap', label: 'Graduation Cap' },
  { value: 'timer', label: 'Timer' },
  { value: 'messageCircle', label: 'Message' },
  { value: 'search', label: 'Search' },
  { value: 'fileText', label: 'Document' },
  { value: 'shoppingCart', label: 'Shopping Cart' },
  { value: 'barChart3', label: 'Chart' },
  { value: 'home', label: 'Home' },
  { value: 'helpCircle', label: 'Help' },
  { value: 'user', label: 'User' },
];

/**
 * Resolve an icon name from CMS value, emoji legacy value, or service id fallback.
 */
export const resolveIcon = (value, serviceId = null) => {
  if (value && ICON_MAP[value]) {
    return value;
  }
  if (value && EMOJI_TO_ICON[value]) {
    return EMOJI_TO_ICON[value];
  }
  if (serviceId && SERVICE_ICON_DEFAULTS[serviceId]) {
    return SERVICE_ICON_DEFAULTS[serviceId];
  }
  return 'circle';
};
